import { Link } from "react-router-dom";
import { useSite, tx } from "@/lib/lang";
import { ui } from "@/lib/uiStrings";
import { scrollToSection } from "@/hooks/useLenis";

export default function Footer() {
  const { content, lang } = useSite();
  const footer = content.footer || {};
  const t = ui[lang];
  const year = new Date().getFullYear();

  const sectionLinks = [
    ["#chi-siamo", t.nav.chi],
    ["#manifesto", t.nav.manifesto],
    ["#servizi", t.nav.servizi],
    ["#target", t.nav.target],
    ["#metodo", t.nav.metodo],
    ["#contatti", t.nav.contatti],
  ];

  return (
    <footer data-testid="footer-section" className="border-t border-ice/5 bg-surface/40">
      <div className="mx-auto max-w-7xl px-6 py-16 grid md:grid-cols-[1.3fr_1fr_1fr_1fr] gap-12">
        <div>
          <img src="/ethic-logo.png?v=6" alt="ETHIC ENERGY" className="h-8 w-auto" />
          <p className="mt-6 text-sm text-muted-foreground leading-relaxed max-w-sm">{tx(footer.note, lang)}</p>
          {content.contatti?.owner_email && (
            <a
              data-testid="footer-email"
              href={`mailto:${content.contatti.owner_email}`}
              className="mt-4 inline-block text-sm font-medium text-royal hover:text-azure transition-colors"
            >
              {content.contatti.owner_email}
            </a>
          )}
          <p className="mt-6 font-mono text-xs text-muted-foreground/70 leading-relaxed">
            {tx(footer.legal, lang)}
            <br />
            {tx(footer.piva, lang)}
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">{t.footer.sections}</p>
          <ul className="space-y-3">
            {sectionLinks.map(([hash, label]) => (
              <li key={hash}>
                <button
                  data-testid={`footer-link-${hash.slice(1)}`}
                  onClick={() => scrollToSection(hash)}
                  className="text-sm text-ice/70 hover:text-azure transition-colors"
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">{t.nav.insights}</p>
          <ul className="space-y-3">
            <li>
              <Link
                data-testid="footer-osservatorio-link"
                to="/osservatorio-energia"
                className="text-sm text-ice/70 hover:text-azure transition-colors"
              >
                {t.nav.ossTitle}
              </Link>
            </li>
            <li>
              <button
                data-testid="footer-dati-link"
                onClick={() => scrollToSection("#reporting")}
                className="text-sm text-ice/70 hover:text-azure transition-colors"
              >
                {t.labels.reporting}
              </button>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">{t.footer.legal}</p>
          <ul className="space-y-3">
            <li>
              <span data-testid="footer-rr-advisory-link" className="text-sm text-ice/70">
                RR Solutions srl
              </span>
            </li>
            <li>
              <Link data-testid="footer-privacy-link" to="/privacy-policy" className="text-sm text-ice/70 hover:text-azure transition-colors">
                {t.footer.privacy}
              </Link>
            </li>
            <li>
              <Link data-testid="footer-cookie-link" to="/cookie-policy" className="text-sm text-ice/70 hover:text-azure transition-colors">
                {t.footer.cookie}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ice/5">
        <div className="mx-auto max-w-7xl px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p data-testid="footer-copyright" className="font-mono text-xs text-muted-foreground/60">
            © {year} RR Solutions srl — ETHIC ENERGY. {t.footer.rights}
          </p>
          <p className="font-mono text-xs text-muted-foreground/40">{tx(footer.tagline, lang) || "energia governata · governed energy"}</p>
        </div>
      </div>
    </footer>
  );
}
